import { CallToAction } from '../../types/cmsProduct';
import { getApplyButtonLabel } from '../../utils/helpers/router';
import { BrandId } from '../../utils/override/override';
import { FulfilmentPath } from '../../utils/tiAttributes';
import { tr } from '../../utils/translations/tr';

type StaticText = Record<string, string>;

/**
 * Standardised TI apply-CTA label (CMS-1643), page-wide (sticky footer + M3b tier
 * cards + nav Apply). Lives under `components/ApplyCta/` with the rest of the CTA
 * logic (`ApplyCtaLink`, `resolveCtaUrlForVertical`, `useCtaUrl`).
 * - MoneyHero: "Apply Now" / "立即投保" — path-independent.
 * - SingSaver: "Instant Checkout" (e2e) / "Buy Now" (click_out).
 * - Absent / unrecognised path (SingSaver) or any other brand: the existing
 *   `getApplyButtonLabel` default (per-instance override → CTA label → default).
 */
export function resolveTiCtaLabel(params: {
  brand?: BrandId;
  staticText: StaticText;
  fulfilmentPath?: FulfilmentPath;
  callToAction?: CallToAction;
  ctaLabelOverride?: string;
}): string {
  const { brand, staticText, fulfilmentPath, callToAction, ctaLabelOverride } =
    params;

  if (brand === 'moneyhero') {
    return tr('ti_apply_now', staticText);
  }

  if (brand === 'singsaver') {
    if (fulfilmentPath === 'e2e') return tr('ti_instant_checkout', staticText);
    if (fulfilmentPath === 'click_out') return tr('ti_buy_now', staticText);
  }

  return getApplyButtonLabel(
    tr('ti_apply_now', staticText),
    ctaLabelOverride,
    callToAction,
  );
}
